import { AdminAction } from './admin.action';
import { AdminState } from './admin.state';

export const adminReducer = (state: AdminState, action: AdminAction): AdminState => {
  switch (action.type) {
    case 'SET_ADMIN_SELECTED_LOCATION':
      return { ...state, selectedLocationId: action.payload };
    case 'SET_ADMIN_SELECTED_DEPLOYMENT':
      return { ...state, selectedDeploymentId: action.payload };

    case 'ADMIN_SET_USERS':
      return {
        ...state,
        users: { ...state.users, data: action.payload.users, totalUsers: action.payload.totalUsers, loading: false, error: null },
      };
    case 'ADMIN_DELETE_USER':
      return {
        ...state,
        users: {
          ...state.users,
          data: state.users.data.filter((user) => user.user_id !== action.payload),
          totalUsers: state.users.totalUsers - 1,
        },
      };
    case 'ADMIN_SET_USERS_LOADING':
      return { ...state, users: { ...state.users, loading: action.payload } };
    case 'ADMIN_SET_USERS_ERROR':
      return { ...state, users: { ...state.users, error: action.payload, loading: false } };
    case 'ADMIN_SET_USERS_PAGINATION':
      return { ...state, users: { ...state.users, page: action.payload.page, rowsPerPage: action.payload.rowsPerPage } };
    case 'ADMIN_SET_USERS_SORTING':
      return { ...state, users: { ...state.users, orderBy: action.payload.orderBy, order: action.payload.order } };
    case 'ADMIN_SET_PROJECTS':
      return { ...state, projects: action.payload };
    case 'ADMIN_SET_DEVICES':
      return { ...state, devices: action.payload };
    case 'ADMIN_DELETE_DEVICE':
      return {
        ...state,
        devices: state.devices.filter((device) => device.device_id !== action.payload),
      };
    case 'ADMIN_SET_DEPLOYMENT_LIST':
      return { ...state, deployments: action.payload };

    case 'ADMIN_SET_PROJECT_MEDIA':
      return {
        ...state,
        projectMedia: {
          ...state.projectMedia,
          [action.payload.projectId]: action.payload.media,
        },
      };

    case 'ADMIN_ADD_PROJECT_MEDIA':
      return {
        ...state,
        projectMedia: {
          ...state.projectMedia,
          [action.payload.projectId]: [
            action.payload.mediaItem,
            ...(state.projectMedia[action.payload.projectId] || []),
          ],
        },
      };

    case 'ADMIN_UPDATE_PROJECT_MEDIA':
      return {
        ...state,
        projectMedia: {
          ...state.projectMedia,
          [action.payload.projectId]: (state.projectMedia[action.payload.projectId] || []).map(item =>
            item.media_id === action.payload.mediaItem.media_id ? action.payload.mediaItem : item
          ),
        },
      };

    case 'ADMIN_DELETE_PROJECT_MEDIA':
      return {
        ...state,
        projectMedia: {
          ...state.projectMedia,
          [action.payload.projectId]: (state.projectMedia[action.payload.projectId] || []).filter(
            item => item.media_id !== action.payload.mediaId
          ),
        },
      };

    default:
      return state;
  }
};